var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueberries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#509D34;}\n\t.st2{fill:#1D8855;}\n\t.st3{fill:#5F578D;}\n\t.st4{fill:#818EAD;}\n\t.st5{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.19,96.12c28.99,1.57,22.7-35.59,22.7-35.59C96.26,71.8,106.19,96.12,106.19,96.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.22,56.61c-1.15-0.68-2.55-0.82-3.81-0.39c-12.41,4.29-20.71,10.91-24.68,19.67 c-5.05,11.16-0.93,21.52-0.75,21.95c0.67,1.63,2.21,2.73,3.97,2.83c0.68,0.04,1.35,0.05,2,0.05c8.04,0,14.41-2.72,18.94-8.08 c9.93-11.75,6.64-32.02,6.49-32.88C133.16,58.45,132.37,57.29,131.22,56.61z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.54,101.8c0.97-29.02-36.06-21.95-36.06-21.95C76.44,112.24,100.54,101.8,100.54,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.52,77.61c-0.66,1.17-0.77,2.56-0.31,3.82c4.55,12.32,11.34,20.48,20.18,24.26 c11.26,4.82,21.53,0.48,21.97,0.29c1.62-0.7,2.68-2.27,2.74-4.03c0.02-0.69,0.03-1.35,0.01-2 c-0.17-8.04-3.02-14.35-8.47-18.77c-11.96-9.68-32.15-5.97-33-5.81C62.32,75.63,61.18,76.44,60.52,77.61z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.42,92.45c-15.73,6.93-22.87,25.31-15.94,41.04c6.93,15.73,25.31,22.87,41.04,15.94 c15.73-6.93,22.87-25.31,15.94-41.04C130.53,92.65,112.15,85.52,96.42,92.45z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 116.71,
    cy: 106.22,
    rx: 8.44,
    ry: 9.07
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueberries);
export default __webpack_public_path__ + "static/media/Blueberries.edc61a925a0147af1cc1f9e3717384c1.svg";
export { ForwardRef as ReactComponent };